import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { bookingPayment } from "../data/siteData";
import { db } from "./firebase";

export async function createBooking(bookingDetails) {
  const booking = {
    ...normalizeBookingDetails(bookingDetails),
    payment: {
      provider: "paypal_me",
      amount: bookingPayment.amount,
      currency: bookingPayment.currency,
      status: "manual_check_required"
    },
    source: "landing_page",
    status: "payment_unverified",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  };

  const bookingRef = await addDoc(collection(db, "bookings"), booking);

  return {
    id: bookingRef.id,
    ...booking,
    createdAt: null,
    updatedAt: null
  };
}

function normalizeBookingDetails(bookingDetails) {
  return {
    fullName: cleanText(bookingDetails.fullName),
    email: cleanText(bookingDetails.email).toLowerCase(),
    suggestedCallTime: cleanText(bookingDetails.suggestedCallTime),
    suggestedCallTimeSast: cleanText(bookingDetails.suggestedCallTimeSast),
    timezone: cleanText(bookingDetails.timezone),
    musicianBackground: cleanText(bookingDetails.musicianBackground),
    goals: cleanText(bookingDetails.goals),
    inspirationPianist: cleanText(bookingDetails.inspirationPianist),
    videoLinks: [
      bookingDetails.videoLinkOne,
      bookingDetails.videoLinkTwo,
      bookingDetails.videoLinkThree
    ].map(cleanText).filter(Boolean),
    socialLinks: splitOptionalLinks(bookingDetails.socialLinks)
  };
}

function cleanText(value = "") {
  return String(value).trim();
}

function splitOptionalLinks(value = "") {
  return String(value)
    .split(/\n|,/)
    .map((link) => link.trim())
    .filter(Boolean);
}
